export const checkIsPdf = (uri) =>
    uri?.startsWith("data:application/pdf") || uri?.endsWith(".pdf")

// A file picked on the web is a `blob:` address, which says nothing of its
// type: read the type the file carries before falling back on its address.
export const isPdfFile = (file) =>
    file?.mimeType === "application/pdf" ||
    !!file?.name?.toLowerCase().endsWith(".pdf") ||
    checkIsPdf(file?.uri)
